exports = module.exports = require("./../../../node_modules/custom-react-scripts/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._2UWkfvaLXJ59XtVgKyR1hL{font-weight:300;min-height:4em}", ""]);

// exports
exports.locals = {
	"header": "_2UWkfvaLXJ59XtVgKyR1hL"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/custom-react-scripts/~/css-loader?modules&-autoprefixer&importLoaders=1!./~/custom-react-scripts/~/postcss-loader!./src/components/header/style.css
 ** module id = 346
 ** module chunks = 0
 **/